define('helperContent-cloneInitEntity',['content--get-entity.es', 'helperContent-cloneEntity', 'content--get-quiz-game.es'], function(getEntityES, cloneEntity, getQuizGameES) {
    'use strict';

    var getEntity = getEntityES.default,
        getQuizGame = getQuizGameES.default;

     // Clone entity to start with in Training
    var cloneInitEntity = function(training, user, previewMode, previewID) {
        var entity = null,
            game = null,
            hash = (location.hash && location.hash.indexOf('#') > -1) ? location.hash.substr(1) : '',
            isParentQuiz = function(entity, entities) {
                var parentID = entity.contentEntity.parentId,
                    parentEntity;

                if (parentID) {
                    parentEntity = getEntity(parentID, entities);
                }

                return (parentEntity && parentEntity.hasOwnProperty('typeId') && parentEntity.typeId === 19) ? true : false;
            },
            entities = (training && training.hasOwnProperty('contentEntities')) ? training.contentEntities : null,
            fromLastVisited = (training && training.hasOwnProperty('continueFromLastVisitedPage') && training.continueFromLastVisitedPage) ? true : false,
            lastVisitedID = (user && user.hasOwnProperty('lastVisitedContentEntityId') && user.lastVisitedContentEntityId) ? user.lastVisitedContentEntityId : false;

        if (!Array.isArray(entities) || entities.length === 0) {
            return null;
        }

        if (previewMode && previewID) {
            entity = getEntity(previewID, entities);

            if (entity) {
                return cloneEntity(entity);
            }
        }

        entity = (hash) ? getEntity(hash, entities) : (fromLastVisited && lastVisitedID) ? getEntity(lastVisitedID, entities) : null;

        if (!entity) {
            entity = entities[0];
        } else {
            game = getQuizGame(entity.contentEntity.parentId, entities);

            if (game && game.isQuizGame) {
                entity = getEntity(game.ID, entities);
            } else if (isParentQuiz(entity, entities)) {
                entity = getEntity(entity.contentEntity.parentId, entities);
            }
        }

        return (entity) ? cloneEntity(entity) : null;
    };

    return cloneInitEntity;
});

